import { render, staticRenderFns } from "./VaSwitch.vue?vue&type=template&id=8d6f1fc8&scoped=true&"
import script from "./VaSwitch.vue?vue&type=script&lang=ts&"
export * from "./VaSwitch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d6f1fc8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d6f1fc8')) {
      api.createRecord('8d6f1fc8', component.options)
    } else {
      api.reload('8d6f1fc8', component.options)
    }
    module.hot.accept("./VaSwitch.vue?vue&type=template&id=8d6f1fc8&scoped=true&", function () {
      api.rerender('8d6f1fc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/VaSwitch.vue"
export default component.exports